<template>
  <div class="supply-hall">
    <!-- <img src="../../../assets/img/index/temp/tabs-4.png" alt=""></div> -->
    <!-- banner -->
    <div class="cloud-banner">
      <div class="banner-main">
        <p class="title">众包市场</p>
        <p class="txt">旭阳云供需对接平台打通了能源化工行业的研发、生产、制造、采购、方案设计、项目实施等供需链路，便于需求方、供应方能在同一平台上实现线上资源互换，线上资源对接，让供需连通起来。</p>
      </div>
    </div>
    <!-- line -->
    <div v-show="navBarFixed" class="detail-top-line"></div>
    <!-- nav -->
    <div ref="pronbit" class="news-nav" :class="navBarFixed == true ? 'navBarWrap' :''">
      <ul class="nav-main">
        <li 
          v-for="(item, index) in navList" 
          :key="item.id" 
          :class="{ 'hover-li': tabsEm === index }"
          @click="jump(index)">
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div v-show="navBarFixed" class="news-nav"></div>
    <!-- filed1 -->
    <div class="hall-filed1 scroll-filed">
      <div class="filed-main">
        <h2>供需对接平台</h2>
        <p class="line-img">
          <img src="../../../assets/img/index/lanxiahua.png" alt="">
        </p>
        <div class="platform">
          <img src="../../../assets/img/energy-environment/hall0.png" alt="">
          <p class="content">
            <span>为了打通能源化工行业的研发、生产、制造、采购、方案设计、项目实施等供需链路，旭阳云平台开发供需对接平台，便于需求方、供应方能在同一平台上实现线上资源互换，线上资源对接，让供需连通起来。</span>
            <span>“需求”：里面所有的内容均为需求发布，将不同分类领域需求集中起来展示，便于可提供支持的各方供应商看到信息后快速对接，需求方无需再四处打探咨询；</span>
            <span>“供应”：方便企业展示其产品、技术、解决方案等，需求方也可在此处查找匹配的需求并联系。</span>
          </p>
        </div>
      </div>
    </div>
    <!-- filed2 -->
    <div class="hall-filed2 scroll-filed">
      <div class="filed-main">
        <h2 class="h-bai">加入标准</h2>
        <p class="line-img">
          <img src="../../../assets/img/index/baixiahua.png" alt="">
        </p>
        <ul>
          <li v-for="(item, index) in weatherList" :key="index">
            <img :src="item.img" alt="">
            <p class="title">{{item.title}}</p>
            <p class="content">{{item.content}}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- filed3 -->
    <div class="hall-filed3 scroll-filed">
      <div class="filed-main">
        <h2>服务内容</h2>
        <p class="line-img">
          <img src="../../../assets/img/index/lanxiahua.png" alt="">
        </p>
        <ul>
          <li v-for="(item, index) in appList" :key="index">
            <div class="left">
              <p class="title">{{item.title}}</p>
              <p class="content">{{item.txt}}</p>
            </div>
            <div class="right">
              <img :src="item.img" alt="">
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { SecondPage } from '@/mixins/SecondPage'
  export default {
    mixins: [SecondPage],
    data() {
      return {
        navList: [{id: 'filed1', name: '供需对接平台'}, {id: 'filed2', name: '加入标准'}, {id: 'filed3', name: '服务内容'}],
        weatherList: [
          {
            img: require('../../../assets/img/energy-environment/hall-li1.png'),
            title: '加入标准',
            content: '旭阳云平台注册并实名的企业'
          },
          {
            img: require('../../../assets/img/energy-environment/hall-li2.png'),
            title: '需求发布',
            content: '旭阳云平台众包市场发布5条以上的需求'
          },
          {
            img: require('../../../assets/img/energy-environment/hall-li3.png'),
            title: '能力供给',
            content: '发布企业供应的产品服务能力，以便更好的进行对接'
          }
        ],
        appList: [
          {
            img: require('../../../assets/img/energy-environment/hall1.png'),
            title: '免费发布',
            txt: '提供一站式的发布流程，便于需求方进行发布。'
          },
          {
            img: require('../../../assets/img/energy-environment/hall2.png'),
            title: '资源开放',
            txt: '通过“平台+需求”方式对接供需双方，面向广大企业提供供需信息和对接撮合服务，在生产、储备、运输等环节全面保障生产设备和物资供应。'
          },
          {
            img: require('../../../assets/img/energy-environment/hall3.png'),
            title: '需求对接',
            txt: '便捷高效的供需对接渠道，提供旭阳集团内外的庞大企业需求，以便线上更多企业响应。'
          },
          {
            img: require('../../../assets/img/energy-environment/hall4.png'),
            title: '优选服务商',
            txt: '优选具有核心竞争力和品牌影响力的服务企业，帮助购买主体更好掌握专业服务信息，促进供需精准对接。'
          }
        ]
      }
    },
    methods: {

    }
  }
</script>

<style lang="less" scoped>
.navBarWrap {
  position: fixed;
  left: 0;
  top: 61px;
  z-index: 50;
}
  img {
    vertical-align: top;
  }
  h2 {
    font-size: 36px;
    font-weight: 600;
    color: #494949;
    text-align: center;
  }
  .line-img {
    margin: 35px auto;
    display: flex;
    justify-content: center;
    img {
      height: 16px;
    }
  }
  .filed-main {
    width: 1280px;
    margin: 0 auto;
    .h-bai {
      color: #FFFFFF;
    }
  }
  .cloud-banner {
    width: 100%;
    height: 440px;
    padding-top: 146px;
    box-sizing: border-box;
    background-image: url("../../../assets/img/energy-environment/hall-banner.png");
    background-repeat: no-repeat;
    background-position:center center;
    /*以下的是为了防止容器高度和图片高度不一致而导致出现空白的区域*/
    background-size:cover;
    color: #FFFFFF;
    .banner-main {
      width: 1280px;
      margin: 0 auto;
      .title {
        font-size: 40px;
        font-weight: bold;
      }
      .txt {
        margin-top: 38px;
        font-size: 16px;
        line-height: 36px;
        width: 920px;
      }
    }
  }
  .news-nav {
    width: 100%;
    height: 50px;
    background-color: #fff;
    box-shadow: 0px 9px 7px 0px rgba(3, 3, 3, 0.05);
    .nav-main {
        width: 1280px;
        height: 50px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        li {
          display: block;
          text-align: center;
          line-height: 50px;
          text-align: center;
          cursor: pointer;
          border-bottom: 3px solid #fff;
          font-size: 16px;
          color: #111111;
          margin: 0 102px;
        }
        .hover-li {
          color: #45A4F8;
        }
        li:hover {
          color: #45A4F8;
        }
      }
  }
  .hall-filed1 {
    background: #F4F5F7;
    padding: 100px 0;
    .platform {
      height: 360px;
      margin-top: 45px;
      width: 100%;
      padding: 30px;
      box-sizing: border-box;
      background-color: #FFFFFF;
      display: flex;
      justify-content: space-between;
      img {
        width:500px;
        height: 300px;
      }
      .content {
        width: 640px;
        font-size: 16px;
        font-weight: 400;
        color: #494949;
        line-height: 24px;
        span {
          display: inline-block;
          margin-bottom: 30px;
        }
      }
    }
  }
  .hall-filed2 {
    width: 100%;
    height: 560px;
    padding-top: 146px;
    box-sizing: border-box;
    background-image: url("../../../assets/img/energy-environment/hall-bg.png");
    background-repeat: no-repeat;
    background-position:center center;
    background-size:cover;
    ul {
      width: 100%;
      display: flex;
      justify-content: space-between;
      li {
        width: 412px;
        height: 240px;
        background: #FCFCFC;
        border: 1px solid #E2E2E2;
        box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
        box-sizing: border-box;
        img {
          width: 68px;
          height: 68px;
        }
        .title {
          margin: 21px 0;
          font-size: 18px;
          font-weight: 400;
          color: #181818;
        }
        .content {
          font-size: 14px;
          font-weight: 400;
          color: #494949;
        }
      }
      li:hover {
        box-shadow: 0 0 15px 5px #F7F8FA;
      }
    }
  }
  .hall-filed3 {
    width: 100%;
    box-sizing: border-box;
    background: #F7F8FA;
    padding: 100px 0;
    ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 630px;
        height: 200px;
        background: #FFFFFF;
        border: 1px solid #E2E2E2;
        // margin-right: 16px;
        margin-bottom: 49px;
        display: flex;
        .left {
          width: 314px;
          box-sizing: border-box;
          padding: 39px 39px 0 39px;
          .title {
            font-size: 18px;
            font-weight: 400;
            color: #181818;
            margin-bottom: 14px;
          }
          .content {
            font-size: 14px;
            font-weight: 400;
            color: #494949;
            line-height: 24px;
          }
        }
        .right {
          width: 315px;
          height: 200px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      li:nth-child(2n) {
        margin-right: 0px;
      }
      li:hover {
        box-shadow: 0 0 20px 8px rgba(0, 0, 0, 0.2);
      }
    }
  }
</style>
